import { inject } from '@angular/core';
import { StorageService, UiPrefsService } from '@cosmos/angular/utils';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEn from '@angular/common/locales/en';



export function initConfig(): any {
  return () => {
    registerLocaleData(localeEs, 'es-ES');
    registerLocaleData(localeEn, 'en-US');
    const storageService = inject(StorageService);
    const uiPrefs = inject(UiPrefsService);
    const translate = inject(TranslateService);

    const body = document.querySelector('html');
    // Read the raw key rather than uiPrefs.themeMode() — the signal always
    // resolves to a concrete 'light'|'dark' (default 'light'), which would
    // lose the "no stored preference -> follow the OS" fallback below.
    const storedTheme = storageService.getItem('ui.theme.mode'); // JSON-quoted string, or null
    if (
      storedTheme === JSON.stringify('dark') ||
      (storedTheme === null &&
        window.matchMedia('(prefers-color-scheme: dark)').matches)
    )
      body.classList.add('dark');

    translate.use(uiPrefs.locale());

    const sizeMap: Record<string, string> = { small: '13px', default: '14px', large: '16px' };
    body.style.fontSize = sizeMap[uiPrefs.textSize()] ?? '14px';
  };
}
